import React, { Component } from 'react';
import 'firebase/firestore';
import { getFirebase } from './firestore';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { multiSelectFilter, textFilter } from 'react-bootstrap-table2-filter';
import 'bootstrap/dist/css/bootstrap.css';

const selectOptions = {
  0: 'Weele ter',
  1: 'Boer de - Penrose'
};

const columns = [
  {
    dataField: 'id',
    text: 'Product ID',
    hidden: true
  },
  { dataField: 'IsOnderOnsLid', hidden: true },
  {
    dataField: 'Ranglijst',
    text: 'No:'
  },
  {
    dataField: 'Voornaam',
    text: 'Voornaam'
  },
  {
    dataField: 'Achternaam',
    text: 'Achternaam',
    condensed: true
  }
  // {
  //   dataField: 'displayNaam',
  //   text: 'Spelers...',
  //   filter: textFilter()
  //   //formatter: cell => selectOptions[cell]
  //   // filter: multiSelectFilter({
  //   //   options: selectOptions,
  //   //   //withoutEmptyOption: true,
  //   //   className: 'test-classname'
  //   // })
  // }
];

const rowStyle2 = (row, rowIndex) => {
  const style = {};
  if (row.Spelsoort === '5Pins') {
    style.backgroundColor = 'gold';
  } else {
    style.backgroundColor = '#F0FFF';
  }

  // if (row.IsOnderOnsLid === true) {
  //   style.fontWeight = 'bold';
  //   style.color = 'blue';
  // }
  // if (rowIndex >= 0) {
  //   if (row.IsOnderOnsLid === true) {
  //     style.fontWeight = 'bold';
  //     style.color = 'blue';
  //   }
  // }

  return style;
};

const CaptionElement = () => (
  <h5
    style={{
      borderRadius: '0.25em',
      textAlign: 'center',
      color: 'purple',
      border: '1px solid purple',
      padding: '0.5em'
    }}
  >
    <div>Ranglijst 5Pins eindstand NK2019 </div>
    {/* <span style={{ backgroundColor: 'gold', fontSize: 12 }}>Geel = 5Pins.</span>{' '}
    <span style={{ fontSize: 12 }}>Wit = biatlon.</span> */}
    {/* <span style={{ color: 'blue', fontSize: 12 }}>Donkerblauw = OnderOns spe(e)l(st)er</span> */}
  </h5>
);

const firestore = getFirebase();

export default class Ranglijst5Pins extends Component {
  constructor(props) {
    super(props);
    this.state = { Speelschema: [] };
  }
  componentDidMount() {
    //this.();
    this.setState({ loaded: true });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    //console.log('Snapshot', snapshot);
    if (snapshot !== null) {
      // console.log('Laden van gegevens');
      if (prevState.loaded !== this.state.loaded) {
        this.getData();
      }
    }
  }

  getData = async () => {
    var wedstrijdschemaRef = firestore.collection(`/OnderOns/AlleSpelerslijsten/NK5Pins/`);

    const HaalDataOp = () => {
      var that = this;
      // console.log('Speelschema voor vullen', that.state.Speelschema);
      wedstrijdschemaRef
        .orderBy('Ranglijst')
        //.limit(2)
        .get()
        .then(querySnapshot => {
          //console.log('Querysnapshot', querySnapshot);

          const wedstrijden = [];
          querySnapshot.forEach(function(doc) {
            // Eerst de uitslag platmaken
            let tmpRec = [];

            tmpRec = {
              Ranglijst: doc.data().Ranglijst,
              Voornaam: doc.data().Naam,
              Achternaam: doc.data().Achternaam,

              id: doc.data().id
            };
            //console.log('TmpRec', tmpRec);
            wedstrijden.push(tmpRec);
          });
          const children = wedstrijden.map(function(doc) {
            return {
              Ranglijst: doc.Ranglijst,
              Voornaam: doc.Voornaam,
              Achternaam: doc.Achternaam,
              id: doc.id
            };
          });
          //console.log('Children', children);
          this.setState({ Speelschema: children });
        });
      //console.log('Wedstrijden!!', wedstrijden);
      //let children = undefined;
    };
    HaalDataOp();
  };

  render() {
    //console.log('Speelschema', this.state.Speelschema);

    return (
      <div>
        <div>
          <CaptionElement />
        </div>
        <div>
          <BootstrapTable
            striped
            //hover
            condensed
            keyField="id"
            data={this.state.Speelschema}
            columns={columns}
            filter={filterFactory()}
            style={{ height: 300 }}
            rowStyle={rowStyle2}
          />
        </div>
      </div>
    );
  }
}
